import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-346d96c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "listbox",
  class: "oxd-autocomplete-dropdown"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_autocomplete_option = _resolveComponent("oxd-autocomplete-option")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_oxd_autocomplete_option, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('general.searching', 'Searching...')), 1)
          ]),
          _: 1
        }))
      : (_ctx.empty)
        ? (_openBlock(), _createBlock(_component_oxd_autocomplete_option, { key: 1 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('general.no_records_found', 'No records found')), 1)
            ]),
            _: 1
          }))
        : _renderSlot(_ctx.$slots, "default", { key: 2 }, undefined, true)
  ]))
}